import styled, { css } from 'styled-components';
import { TStyledButtonIconProperties, TSize } from './button-icon.types';

export const StyledButtonIconWrapper = styled.span`
    display: inline-block;
`;
function setButtonSize(size: TSize): number {
    return size === 'default' ? 4.4 : 6;
}

export const StyledButtonIcon = styled.button<TStyledButtonIconProperties>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ size }) => `${setButtonSize(size)}rem`};
    height: ${({ size }) => `${setButtonSize(size)}rem`};
    background-color: ${({ theme, isOpen }) =>
        isOpen ? theme.color.grey1 : 'transparent'};
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius.default};

    svg {
        display: inline-block;
        width: ${({ size }) => size};
        height: ${({ size }) => size};
        fill: ${({ theme, isInverted, color }) =>
            isInverted ? theme.color.white : color};
    }

    &:hover {
        cursor: pointer;
        svg {
            fill: ${({ theme }) => theme.color.purple};
        }
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.color.white},
            0 0 0 0.4rem ${({ theme }) => theme.color.purpleTint10};
        svg {
            fill: ${({ theme }) => theme.color.purple};
        }
    }

    ${({ isOpen }) =>
        isOpen &&
        css<TStyledButtonIconProperties>`
            background-color: ${({ theme, isInverted }) =>
                isInverted ? theme.color.indigoTint10 : theme.color.grey1};
            border: none;
            border-radius: ${({ theme }) => theme.borderRadius.default};
            svg {
                fill: ${({ theme, isInverted }) =>
                    isInverted ? theme.color.white : theme.color.black};
            }
            &:hover,
            &:focus {
                background-color: transparent;
                svg {
                    fill: ${({ theme }) => theme.color.purpleTint10};
                }
            }
        `}
`;
